<ng-container [formGroup]="form" [ngSwitch]="getFieldDisplayType(field)" *ngIf="formControl">

  <ng-container *ngSwitchCase="FieldDisplayType.Dropdown">
    <mat-form-field *ngIf="field.rowData[0]; let rowData" appearance="fill" [style.font-family]="theme.Detail.Font">
      <mat-label>{{ rowData.fieldTitle }}</mat-label>
      <mat-select #sel [formControlName]="field.rowId" [required]="isRequired">
        <mat-option *ngFor="let o of field.options | fieldSort" [value]="o.valueCode" matTooltip="{{ getOptionTooltip(o) }}">{{ getOptionLabel(o) }}</mat-option>
      </mat-select>
      <mat-hint *ngIf="isRequired">* {{ resources.Required }}</mat-hint>
      <input type="hidden" [name]="getName(field)" [value]="sel.value || null">
    </mat-form-field>
  </ng-container>

  <ng-container *ngSwitchCase="FieldDisplayType.Email">
    <mat-form-field *ngIf="field.rowData[0]; let rowData" appearance="fill" [style.font-family]="theme.Detail.Font">
      <mat-label>{{ rowData.fieldTitle }}</mat-label>
      <input [formControlName]="field.rowId" matInput [placeholder]="rowData.placeholder" [name]="getName(field)" [required]="isRequired" />
      <mat-error *ngIf="formControl.errors && formControl.errors.pattern">{{ resources.InvalidEmail }}</mat-error>
    </mat-form-field>
  </ng-container>

  <ng-container *ngSwitchCase="FieldDisplayType.PlainText">
    <mat-form-field *ngIf="field.rowData[0]; let rowData" appearance="fill" [style.font-family]="theme.Detail.Font">
      <mat-label>{{ rowData.fieldTitle }}</mat-label>
      <input [formControlName]="field.rowId" matInput [placeholder]="rowData.placeholder" [name]="getName(field)" [required]="isRequired" />
    </mat-form-field>
  </ng-container>
  
</ng-container>
